import React, { useState } from 'react';
import { CheckIcon } from 'lucide-react';
import { JOIN_IMAGE, KINDS } from '../data/smaken';
import { Reveal } from '../components/Reveal';
import { Note, ArrowMark } from '../components/Marks';
const STEPS = [{
  n: '01',
  title: 'Berätta om er',
  text: 'Namn, ort och vad ni gör. Det räcker för att vi ska kunna svara.'
}, {
  n: '02',
  title: 'Vi kommer förbi',
  text: 'Vi äter, tittar och pratar. Ingen får plats utan att vi varit där.'
}, {
  n: '03',
  title: 'Ni får en sida',
  text: 'Bilder, öppettider, meny och kontakt. Ni styr allt själva sen.'
}];
export function Join() {
  const [sent, setSent] = useState(false);
  const [form, setForm] = useState({
    name: '',
    city: '',
    kind: '',
    email: '',
    about: ''
  });
  const set = (key: keyof typeof form, value: string) => setForm(prev => ({
    ...prev,
    [key]: value
  }));
  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    setSent(true);
  };
  const inputClass = 'w-full border-b border-black/25 bg-transparent py-3 font-display text-xl outline-none transition-colors duration-150 ease-out placeholder:text-black/25 focus:border-rod sm:text-2xl';
  const labelClass = 'text-[11px] font-bold uppercase tracking-wide2 text-black/45';
  return <div data-id="element-962" data-mp="1k2rbvqd30w3n">
      <div className="mx-auto max-w-page px-5 pb-12 pt-10 md:px-8 md:pt-14" data-id="element-963" data-mp="1k27vwf6zshs9">
        <div className="grid items-end gap-10 lg:grid-cols-[minmax(0,1.1fr),minmax(0,1fr)] lg:gap-14" data-id="element-964" data-mp="1owlv6sorz927">
          <div data-id="element-965" data-mp="1ttm0h1dsw7s9">
            <h1 className="display-xl text-[3rem] uppercase leading-[0.9] sm:text-[4.5rem]" data-id="element-966" data-mp="1tw89l5gcavcl">
              Är du en av oss?
            </h1>
            <p className="mt-6 max-w-lg text-lg leading-relaxed text-black/70" data-id="element-967" data-mp="22uaie76besaf">
              Driver du ett bageri, en restaurang, gårdsbutik, producentverksamhet eller något annat riktigt
              gott? Då vill vi veta om det.
            </p>
            <Note className="mt-5 block" data-id="element-968" data-mp="8ilw1jxr7ng0">Vi tar in få. Men vi tar in rätt.</Note>
          </div>
          <img src={JOIN_IMAGE} alt="Två bagare i dörröppningen till sitt bageri på morgonen" className="aspect-[16/10] w-full object-cover" data-id="element-969" data-mp="dg4afpujiuve" />
        </div>
      </div>

      {/* How it works */}
      <section aria-labelledby="sa-gar-det-till" className="border-y border-black/12" data-id="element-970" data-mp="1pr7x95chrmno">
        <div className="mx-auto max-w-page px-5 py-14 md:px-8" data-id="element-971" data-mp="1ksd2d51927n7">
          <h2 id="sa-gar-det-till" className="sr-only" data-id="element-972" data-mp="1kqtp7naw4cpn">
            Så går det till
          </h2>
          <ol className="grid gap-10 md:grid-cols-3" data-id="element-973" data-mp="1zo2pj6i68qti">
            {STEPS.map(step => <li key={step.n} data-id="element-974" data-mp="1uq19yvjyf9ms">
                <span className="display-xl block text-5xl text-rod" data-id="element-975" data-mp="1uoq50servvu3">{step.n}</span>
                <h3 className="mt-3 font-display text-2xl uppercase" data-id="element-976" data-mp="28k20j20r5qc2">{step.title}</h3>
                <p className="mt-2 leading-relaxed text-black/65" data-id="element-977" data-mp="24gvunvhjy164">{step.text}</p>
              </li>)}
          </ol>
        </div>
      </section>

      {/* Application */}
      <div className="mx-auto max-w-page px-5 py-16 md:px-8 md:py-20" data-id="element-978" data-mp="2didadcr1s0ua">
        <div className="grid gap-14 lg:grid-cols-[minmax(0,1.2fr),minmax(0,1fr)] lg:gap-20" data-id="element-979" data-mp="2x2atzkq0cs4k">
          {sent ? <Reveal data-id="element-980" data-mp="320vtfhxfr7ry">
              <div className="border-2 border-black p-10" data-id="element-981" data-mp="321f208174jtb">
                <CheckIcon className="h-10 w-10 text-rod" aria-hidden="true" data-id="element-982" data-mp="2n565he8owkkl" />
                <h2 className="display-xl mt-5 text-3xl uppercase" data-id="element-983" data-mp="2s3r2z5wk4q5c">Tack. Vi hörs.</h2>
                <p className="mt-3 max-w-md text-lg leading-relaxed text-black/70" data-id="element-984" data-mp="2s5kcqu2gvqhk">
                  Vi läser allt själva och svarar inom en vecka. Håll utkik efter ett mail från
                  hej@smaken.se.
                </p>
              </div>
            </Reveal> : <Reveal data-id="element-985" data-mp="24c275fkj1jjn">
              <form onSubmit={submit} className="space-y-8 border-t-2 border-black pt-8" data-id="element-986" data-mp="29d9ghj2biqsf">
                <div data-id="element-987" data-mp="29awxd2ktqads">
                  <label htmlFor="j-name" className={labelClass} data-id="element-988" data-mp="1vcymw89miy3k">
                    Verksamhetens namn
                  </label>
                  <input id="j-name" required value={form.name} onChange={e => set('name', e.target.value)} placeholder="Lilla Verket" className={inputClass} data-id="element-989" data-mp="1zdsbl3uw4gxi" />
                </div>

                <div className="grid gap-8 sm:grid-cols-2" data-id="element-990" data-mp="1ik9c4wv4kpnr">
                  <div data-id="element-991" data-mp="1dnr7ry3pitby">
                    <label htmlFor="j-city" className={labelClass} data-id="element-992" data-mp="1dmg561lzzrmf">
                      Ort
                    </label>
                    <input id="j-city" required value={form.city} onChange={e => set('city', e.target.value)} placeholder="Växjö" className={inputClass} data-id="element-993" data-mp="19jb4m4lha00f" />
                  </div>
                  <div data-id="element-994" data-mp="2u0zcw0gs4p9z">
                    <label htmlFor="j-kind" className={labelClass} data-id="element-995" data-mp="2u06cdh8eyw0a">
                      Vad är ni?
                    </label>
                    <select id="j-kind" required value={form.kind} onChange={e => set('kind', e.target.value)} className={`${inputClass} cursor-pointer`} data-id="element-996" data-mp="2p2xp528es1s6">
                      <option value="" disabled data-id="element-997" data-mp="36c0avyovsjmj">
                        Välj
                      </option>
                      {KINDS.map(k => <option key={k.id} value={k.id} data-id="element-998" data-mp="2ekkifo0n82oe">
                          {k.sub}
                        </option>)}
                    </select>
                  </div>
                </div>

                <div data-id="element-999" data-mp="2njxrifkuup8l">
                  <label htmlFor="j-email" className={labelClass} data-id="element-1000" data-mp="2nje9yzz4a2v3">
                    E-post
                  </label>
                  <input id="j-email" type="email" required value={form.email} onChange={e => set('email', e.target.value)} placeholder="hej@erverksamhet.se" className={inputClass} data-id="element-1001" data-mp="2shza6zedcmjj" />
                </div>

                <div data-id="element-1002" data-mp="39b76mf7gdomr">
                  <label htmlFor="j-about" className={labelClass} data-id="element-1003" data-mp="39bqsu844yz6l">
                    Vad gör ni som ingen annan gör?
                  </label>
                  <textarea id="j-about" rows={4} value={form.about} onChange={e => set('about', e.target.value)} placeholder="Skriv kort. Vi läser allt." className={`${inputClass} resize-none`} data-id="element-1004" data-mp="3j9n0gpxv7bzy" />
                </div>

                <button type="submit" className="group inline-flex items-center gap-3 bg-rod px-9 py-4 text-[12px] font-bold uppercase tracking-wide2 text-papper transition-colors duration-150 ease-out hover:bg-black" data-id="element-1005" data-mp="35chwqwlmip7v">
                  Skicka ansökan
                  <ArrowMark className="h-3.5 w-8 transition-transform duration-200 ease-out group-hover:translate-x-1" data-id="element-1006" data-mp="27swxrgsnh2b3" />
                </button>
              </form>
            </Reveal>}

          <Reveal delay={0.06} data-id="element-1007" data-mp="s5ryyikwsivd">
            <aside className="bg-blaa p-8 text-papper" data-id="element-1008" data-mp="dfb1197hgb38">
              <h2 className="display-xl text-2xl uppercase" data-id="element-1009" data-mp="dcpwgcfsvh1s">Det här får ni</h2>
              <ul className="mt-6 space-y-4 text-papper/85" data-id="element-1010" data-mp="ief9tyqhw6t1">
                {['En egen sida på Småken med bilder, meny och öppettider.', 'Plats på kartan och i alla relevanta kategorier.', 'Ni styr själva innehållet — foton, produkter, events och erbjudanden.', 'Bokningar, beställningar och kontakt direkt från er sida.', 'Redaktionell bevakning när ni gör något nytt.'].map(item => <li key={item} className="flex items-start gap-3" data-id="element-1011" data-mp="3hrfyo97qf4jq">
                    <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-smor" aria-hidden="true" data-id="element-1012" data-mp="3luuqry8y3bdj" />
                    <span className="leading-relaxed" data-id="element-1013" data-mp="hd1me864frcq">{item}</span>
                  </li>)}
              </ul>
            </aside>
          </Reveal>
        </div>
      </div>
    </div>;
}